import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), 'ArrowBack');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowBack.js
// module id = 2068
// module chunks = 2